export class Address {
  id: string;
  locationName: string;
  shortLocationName: string;
  locationCode: string;
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  zip: string;
  companyName: string;
  contactPhone: string;
  contactName: string;
  contactEmail: string;
  acceptBulk: boolean;
  acceptParcel: boolean;
  requiresLiftGate: boolean;
  isPickupAddress: boolean;


  constructor(data: any = {}) {
    this.id = data.id || null;
    this.locationName = data.locationName || '';
    this.locationCode = data.locationCode || '';
    this.line1 = data.line1 || '';
    this.line2 = data.line2 || '';
    this.line3 = data.line3 || '';
    this.city = data.city || '';
    this.state = data.state || '';
    this.zip = data.zip || '';
    this.companyName = data.companyName || '';
    this.contactPhone = data.contactPhone || '';
    this.contactName = data.contactName || '';
    this.contactEmail = data.contactEmail || '';
    this.acceptBulk = data.acceptBulk || false;
    this.acceptParcel = data.acceptParcel || false;
    this.requiresLiftGate = data.requiresLiftGate || false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/address.ts